import { render } from "./UserRoleList.vue?vue&type=template&id=a13cadc0&scoped=true"
import script from "./UserRoleList.vue?vue&type=script&lang=js"
export * from "./UserRoleList.vue?vue&type=script&lang=js"

import "./UserRoleList.vue?vue&type=style&index=0&id=a13cadc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13cadc0"]])

export default __exports__